const cartCookie = getCookie("cart")
let localCartID = cartCookie ? "gid://shopify/Cart/" + getCookie("cart").replace("%3F","?").replace("%3D","=") : false;

let CartID = localCartID;
let globalCartID_Cookies = localCartID;
let uniqueNumber_Cookies = getCookie("uniqueNumber");
let cartItems;
const discountCode = "";

const createNewCart = async() => {
  try {
    let formData = {
     'items': [{
      'id': 47448041390317,
      'quantity': 0
      }]
    };
    const result = await fetch(
      "/cart/add.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData)
      }
    );
    const cartData = await result.json()
    return cartData
  } catch (error) {
    console.log(error);
    return [];
  }
};

const getCartId = async() => {
  try {
    if(!cartCookie) {
      await createNewCart()
    }
    const result = await fetch(
      "/cart.js",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        }
      }
    );
    const cartData = await result.json()
    const cartIdNew = "gid://shopify/Cart/" + cartData.token
    console.log("new cart token", cartIdNew)
    return cartIdNew
  } catch (error) {
    console.log(error);
    return [];
  }
};

const CertorgraphqlPostRequest = async (Body = ``, Variables = {}) => {
  try {
    const result = await fetch(
      "https://schuttsports.myshopify.com/api/2023-10/graphql.json",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "e2a8754984b8162e16298b6898140495",
          Accept: "application/json",
        },
        body: JSON.stringify({
          query: Body,
          variables: Variables,
        }),
      }
    );

    return await result.json();
  } catch (error) {
    console.log(error);
    return [];
  }
};

const SchuttgraphqlPostRequest = async (Body = ``, Variables = {}) => {
  try {
    const result = await fetch(
      "https://schuttsports.myshopify.com/api/2023-10/graphql.json",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "e2a8754984b8162e16298b6898140495",
          Accept: "application/json",
        },
        body: JSON.stringify({
          query: Body,
          variables: Variables,
        }),
      }
    );

    return await result.json();
  } catch (error) {
    console.log(error);
    return [];
  }
};

const RestApi_GET = async (url) => {
  const request = await fetch(url, {
    method: "GET",
  });
  return await request.json();
};

const RestApi_POST = async (url, data) => {
  const request = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return await request.json();
};

const updateCheckoutButtonMinicart = (price) => {
  if (document.readyState !== "loading") {
    const loader_button__text = document.getElementsByClassName(
      "loader-button__text"
    )[0];
    if (loader_button__text)
      loader_button__text.innerText = "CHECKOUT $" + price;
  } else {
    window.addEventListener("load", (event) => {
      const loader_button__text = document.getElementsByClassName(
        "loader-button__text"
      )[0];
      if (loader_button__text)
        loader_button__text.innerText = "CHECKOUT $" + price;
    });
  }
};

const fetchCartLines = async (CartID) => {
  try {
    let localCartID = ""
    if(CartID) {
      localCartID = CartID;
    } else {
      localCartID = await getCartId();
    }
    const Body = `
    query fetchCartLines { 
      cart(id:"${localCartID}") {
        id
        checkoutUrl
        discountCodes{code}
        lines(first:100) {
        edges {
          node {
            id
            quantity
            attributes{
              key
              value
            }
            estimatedCost {
              subtotalAmount {
                amount
                currencyCode
              }
            }
            sellingPlanAllocation {
                sellingPlan {
                    id
                    name
                }
            }
            merchandise {
              ... on ProductVariant {
                id
                sku
                image{
                  url
                }
                priceV2{
                  amount
                }
                product{
                  id
                  vendor
                  title
                  handle
                  onlineStoreUrl
                  giftProductID: metafield(namespace: "free_gift", key: "product_variant_id") {
                    value
                  }
                  bundleTitle: metafield(namespace: "bundle_title", key: "free_gift") {
                    value
                  }
                  cartDisable: metafield(namespace: "custom", key: "cart_disable") {
                    value
                  }
                }
                selectedOptions{
                  name
                  value
                }
              }
            }
          }
        }
      }
      estimatedCost {
        subtotalAmount {
          amount
          currencyCode
        }
      }
    }
  }
`;

    const data = await CertorgraphqlPostRequest(Body);
    if (!data?.data?.cart?.lines) {
      console.log(
        "something wrong in getAllCartItems() that fetch all items from global cart"
      );
      await createNewCart();
      return false;
    }
    cartItems = data?.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};
const getVariantData = async(id) => {
  try {
    const Body = `
      {
        nodes(ids: "${id}") {
          ... on ProductVariant {
            id
            quantityAvailable
            product {
              title
            }
          }
        }
      }
    `;

    const data = await CertorgraphqlPostRequest(Body);
    return data?.data?.nodes[0]
  } catch (error) {
    console.log(error)
    return false
  }
}
const fetchProduct_PreOrder_data = async (productID) => {
  try {
    const Body = `{
        product(id: "${productID}") {
        sellingPlanGroups(first: 10) {
          nodes {
            sellingPlans(first: 1) {
              nodes {
                id
                name
              }
            }
          }
        }
      }
    }`;

    const response = await CertorgraphqlPostRequest(Body);
    if (!response?.data?.product) {
      console.log("error in fetchProduct_PreOrder_data() ===> ", response);
      return false;
    }
    return response.data.product;
  } catch (error) {
    console.log(error);
  }
};

const addFreeGiftItemToMainCart = async(id) => {
  try {
    const giftTitle = await getVariantData(id)
    document.querySelectorAll(`.line_${id.replace("gid://shopify/ProductVariant/", "")}`).forEach(el => {
      el.textContent = `1 x ${giftTitle.product.title}`;
    });
  } catch (error) {
    console.log(error);
  }
};

const addDiscountCodeToCart = async (DiscountCode) => {
  try {
    const Body = `
    mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          id
          discountCodes{code}
          checkoutUrl
        }
        userErrors {
          field
          message
        }
      }
    }`;

    const Variables = {
      cartId: globalCartID_Cookies,
      discountCodes: [
        // btoa(DiscountCode)
        DiscountCode,
      ],
    };

    const data = await CertorgraphqlPostRequest(Body, Variables);
    // console.log(data);
    if (data?.data?.cartDiscountCodesUpdate?.cart?.id) {
      cartItems = data.data.cartDiscountCodesUpdate;
    }

    if (data?.data?.cartDiscountCodesUpdate.userErrors.length !== 0) {
      console.log(
        "error while addind item to cart : ====>",
        data?.data?.cartDiscountCodesUpdate.userErrors
      );

      // if shopify respond with cartid not existed and return a new cart id contained the item
      if (
        data?.data?.cartDiscountCodesUpdate.userErrors[0].field[0] === "cartId"
      ) {
        console.log("new cart ", data?.data?.cartDiscountCodesUpdate?.cart?.id);
        saveNewCartOnfirebaseAndCookies(
          data?.data?.cartDiscountCodesUpdate?.cart?.id
        );
        return true;
      }
      return false;
    }

    return data.data || false;
  } catch (error) {
    return false;
  }
};

const clearLocalCart = () => {
  try {
    console.log("local cart deleted");
    //jQuery.post(window.Shopify.routes.root + "cart/clear.js");
  } catch (error) {
    console.log(error);
  }
};

const deactivateCartLoader = () => {
  try {
    const domElement = document.getElementById("cartLoader");
    if(domElement) {
      domElement.style.display = "none";
    }
  } catch (error) {
    console.log(error);
  }
};

const saveNewCartOnfirebaseAndCookies = async (cartId) => {
  try {
    setCookie("cartID", cartId, 13);
    const result = await firebase_fuctions.StoreCartID(cartId, uniqueNumber_Cookies);
  } catch (error) {
    console.log(error);
  }
};

const trigger_cutomeEvent = {
  CartNotification_error: (message) => {
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: "error",
            error: message,
          },
        })
      );
    } catch (error) {
      console.log(error);
    }
  },
  globalVariant_add: () => {
    try {
      console.log("event globalVariant:add fire")
      document.documentElement.dispatchEvent(
        new CustomEvent("globalVariant:add", {
          bubbles: true,
        })
      );
    } catch (error) {
      console.log(error);
    }
  },
  globalcartID_updated: () => {
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent("globalcartID:updated", {
          bubbles: true,
        })
      );
    } catch (error) {
      console.log(error);
    }
  },
};

const giftProduct_functions = {
  _productToExpandChildStore: [
    "8831551832384",
    "8006999539949",
    "8210345787629",
    "8089434423533",
    "8113453629677",
    "8160020693229",
    //archived
    // "8194309226733",
    // "8056954323181",
  ],
  _variantToAdd: "gid://shopify/ProductVariant/46404072472813",
  _productToAdd: "gid://shopify/Product/8698453590253",
  _productToExpandMainStore: [
    "f7-2-0-collegiate-helmet",
    "f7-custom-helmet-1",
    "youth-f7-lx1-helmet",
    "f7-2-0-professional-helmet",
    "vengeance-pro-ltd-ii-helmet",

    // archived
    // "f7-vtd-collegiate-helmet",
    // "youth-vengeance-a11-helmet",
  ],
  _checkIfFreeProductAvailableForSale: async () => {
    try {
      const Body = `
      {
        product(id: "${giftProduct_functions._productToAdd}") {
          availableForSale
        }
      }`
      ;
      const data = await CertorgraphqlPostRequest(Body);
      console.log("_checkIfFreeProductAvailableForSale data ===> ", data)
      if(!data?.product?.availableForSale){
        console.log("gift product is not active")
        return false
      }
    return true
    } catch (error) {
      console.log(error);
      return false;
    }
  },
  _findGiftProductInCart: () => {
    try {
      return cartItems?.cart?.lines?.edges.find((cartLine) => {
        return cartLine.node.estimatedCost.subtotalAmount.amount === "0.0";
      });
    } catch (error) {
      console.log(error);
      return false;
    }
  },
  giftProduct_validationCheck: async (cartLines) => {
    try {
      let expandedProduct_exist = false;
      let giftProduct_exist = false;
      let giftProduct_cartLine_id = "";
      cartLines.forEach((item) => {
        console.log("cart item handle name => ", item?.node?.merchandise?.product?.handle)
        giftProduct_functions._productToExpandMainStore.includes(
          item?.node?.merchandise?.product?.handle
        ) && (expandedProduct_exist = true);

        if (
          giftProduct_functions._variantToAdd === item?.node?.merchandise?.id
        ) {
          giftProduct_exist = true;
          giftProduct_cartLine_id = item?.node?.id;
        }
      });
      if (giftProduct_exist && !expandedProduct_exist) {
        // console.log(
        //   "giftProduct_exist ==>",giftProduct_exist,
        //   "expandedProduct_exist ==>",expandedProduct_exist,
        // )
        const status = giftProduct_functions._checkIfFreeProductAvailableForSale()
        if(!status){
          return false
        }
        await updateProductToCart_Request(
          giftProduct_cartLine_id,
          0,
          globalCartID_Cookies
        );
        expandedProduct_exist = false;
        giftProduct_exist = false;
        giftProduct_cartLine_id=""
      }
      expandedProduct_exist = false;
      giftProduct_exist = false;
      giftProduct_cartLine_id=""
    } catch (error) {
      console.log(error);
    }
  },

  GiftProduct_update: async (product_handle, quantity) => {
    try {
      console.log("GiftProduct_update ......")
      if (
        giftProduct_functions._productToExpandMainStore.includes(product_handle)
      ) {
        const giftProduct = giftProduct_functions._findGiftProductInCart();
        console.log("giftProduct ====> ", giftProduct)
        const newQuantity = giftProduct.node.quantity + quantity;
        if (newQuantity === 0) {
          try {
            document.getElementById(`CartItem-${giftProduct.node.id}`).remove();
            await updateProductToCart_Request(
              giftProduct.node.id,
              0,
              globalCartID_Cookies
            );
          } catch (error) {
            console.log(error);
          }
        }
        const status = giftProduct_functions._checkIfFreeProductAvailableForSale()
        if(!status){
          console.log("gidt product are not available for sale")
          return false
        }
        await updateProductToCart_Request(
          giftProduct.node.id,
          newQuantity,
          globalCartID_Cookies
        );
      }else{
        console.log(`product ${product_handle} not related to gift product`)
      }
    } catch (error) {
      console.log(error);
    }
  },

  addGiftProduct: async (productID, quantity) => {
    try {
      // console.log(productID);
      if (
        giftProduct_functions._productToExpandChildStore.includes(productID)
      ) {
        const response = giftProduct_functions._checkIfFreeProductAvailableForSale()
        if(!response){
          return false
        }
        return await addProductToCart_Request(
          giftProduct_functions._variantToAdd,
          quantity,
          globalCartID_Cookies
        );
      }else{
        console.log("this product is not linked with free gift")
      }
    } catch (error) {
      console.log(error);
    }
  },
};

document.addEventListener("variant:updated", async (event) => {
  try {
    console.log("variant:updated");
    await updateProductToCart_Request(
      event.detail.id,
      event.detail.quantity,
      globalCartID_Cookies,
      event.detail.attributes
    );
    //await giftProduct_functions.GiftProduct_update(
    //  event.detail.handle,
    //  event.detail.quantityToUpdate
    //);
    trigger_cutomeEvent.globalVariant_add();
    if(event.detail.quantity === 0){
      event.detail.lineItem.style.display = "none"
      const bannerElement = document.getElementById("cart_banner");
      bannerElement.style.display = "none";
    }
 
  } catch (error) {
    console.log(error);
  }
});
